export default "__VITE_ASSET__DglBQqBX__"